export { default } from './VendorOnboarding';
